import type { User } from '@rtkwlf/rendall';

type UserMap = { [key: string]: string };

export const createUsersMapAndOptions = (data: User[]) => {
  const userMap: UserMap = {};
  const userOptions: { value: string; label: string }[] = [];

  data.forEach(({ id, name }) => {
    if (id && name) {
      userMap[id] = name;
      userOptions.push({ value: id, label: name });
    }
  });

  return { userMap, userOptions };
};
